'use client';

import { useEffect } from 'react';
import { Inter } from "next/font/google";
import "./globals.css";
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import AnalyticsProvider from '@/components/AnalyticsProvider';
import Script from 'next/script';
import AnnouncementBar from '@/components/layout/AnnouncementBar';

const inter = Inter({ subsets: ["latin"] });

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    // Workaround for static export - if URL contains fallback parameters, redirect to main page
    const path = window.location.pathname;
    if (path.includes('[slug]') || path.includes('%5Bslug%5D')) {
      window.location.href = '/';
    }
    
    // Set metadata directly since we can't export it from a client component
    document.title = "Meet Minutes - AI Meeting Assistant";
  }, []);

  return (
    <html lang="en" className="bg-black">
      <head>
        <Script 
          src="https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit" 
          strategy="afterInteractive"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="MeetMinutes - AI powered meeting assistant that captures and summarizes your meetings" />
        <link rel="icon" href="/images/logo/logo.png" />
        <link rel="apple-touch-icon" href="/images/logo/logo.png" />
        <meta name="theme-color" content="#000000" />
        <meta property="og:image" content="/images/logo/logo.png" />
      </head>
      <body className={`${inter.className} flex flex-col min-h-screen bg-black text-gray-300`}>
        <AnalyticsProvider>
          <AnnouncementBar />
          <Header />
          <main className="flex-grow">
            {children}
          </main>
          <Footer />
        </AnalyticsProvider>
      </body>
    </html>
  );
}